import { useCallback } from 'react';
import { formValidate } from '..';
import { useFieldContext } from './useFieldContext';
export const useValidateBeforeAdd = validateBeforeAdd => {
  const {
    preName,
    form
  } = useFieldContext();
  const canAdd = useCallback(async () => {
    if (validateBeforeAdd) {
      try {
        await formValidate(form, `${preName.toString()}.*.*`);
      } catch (e) {
        if (Array.isArray(e)) {
          return false;
        }

        throw e;
      }
    }

    return true;
  }, [form, preName, validateBeforeAdd]);
  return {
    canAdd
  };
};
//# sourceMappingURL=es/hooks/useValidateBeforeAdd.js.map